import React from 'react';
import { Section } from './Section';
export function SolutionSection() {
  const pillars = [{
    icon: '🧠',
    title: 'Reprogramación Mental',
    desc: 'Técnicas probadas para interrumpir el loop de pensamientos nocturnos y entrenar al cerebro a soltar.'
  }, {
    icon: '🌙',
    title: 'Rituales de Transición',
    desc: 'Rutinas concretas que le enseñan al cuerpo que es hora de descansar — no de procesar el día.'
  }, {
    icon: '📵',
    title: 'Ambiente y Hábitos',
    desc: 'Cambios simples en tu entorno y rutina nocturna que potencian todo lo anterior.'
  }];
  return <Section className="bg-bgLight py-20 px-4 sm:px-6 lg:px-8" data-id="element-252">
      <div className="max-w-6xl mx-auto" data-id="element-253">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-headlineDark mb-16 max-w-3xl mx-auto" data-id="element-254">
          Un sistema de 3 pilares para recuperar tu sueño — sin medicación
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-255">
          {pillars.map((pillar, i) => <div key={i} className="bg-white rounded-2xl p-8 shadow-sm border border-cardBorder hover:shadow-md transition-shadow" data-id="element-256">
              <div className="text-4xl mb-6 bg-bgLight text-ctaFrom w-16 h-16 rounded-full flex items-center justify-center" data-id="element-257">
                {pillar.icon}
              </div>
              <h3 className="font-serif text-xl font-bold text-headlineDark mb-4" data-id="element-258">
                {pillar.title}
              </h3>
              <p className="text-bodyOnLight leading-relaxed" data-id="element-259">{pillar.desc}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}